import { Navigate, Route, Routes, Link, useNavigate, useLocation } from 'react-router-dom'
import { mediaUrl } from './lib/api'
import { useAuth } from './lib/auth'
import { LoginPage } from './pages/LoginPage'
import { HomePage } from './pages/HomePage'
import { DiscoverPage } from './pages/DiscoverPage'
import { EventPage } from './pages/EventPage'
import { PicksPage } from './pages/PicksPage'
import { RoomPage } from './pages/RoomPage'
import { GamePage } from './pages/GamePage'
import { WalletPage } from './pages/WalletPage'
import { AdminPage } from './pages/AdminPage'
import { ProfilePage } from './pages/ProfilePage'

function Shell({ children }: { children: React.ReactNode }) {
  const { user, wallet, logout } = useAuth()
  const nav = useNavigate()
  const loc = useLocation()
  const linkClass = (path: string) =>
    `tbtn${loc.pathname === path || (path !== '/' && loc.pathname.startsWith(path)) ? ' active' : ''}`

  return (
    <div className="shell">
      <div className="app-window">
        <header className="titlebar">
          <div className="brand-row">
            <img src="/assets/mma/lobby-icon/full-color.png" alt="" />
            <div className="t">
              Ultimate Sports <small>Friends Edition</small>
            </div>
          </div>
          <div className="win-btns" aria-hidden>
            <i className="mi" />
            <i className="ma" />
            <i className="cl" />
          </div>
        </header>

        <div className="menubar is-inert">
          <span>File</span>
          <span>View</span>
          <span>Pools</span>
          <span>Watch</span>
          <span>Help</span>
        </div>

        <div className="toolbar">
          <nav className="nav-links">
            <Link className={linkClass('/')} to="/">
              Lobby
            </Link>
            <Link className={linkClass('/discover')} to="/discover">
              Discover
            </Link>
            <Link className={linkClass('/profile')} to="/profile">
              Profile
            </Link>
            <Link className={linkClass('/wallet')} to="/wallet">
              Wallet
            </Link>
            <Link className={linkClass('/admin')} to="/admin">
              Ops
            </Link>
          </nav>
          <div className="tb-spacer" />
          {wallet && (
            <span className="wallet-chip" data-testid="wallet-chip" title="Demo credits">
              <span className="wallet-ico" />
              {wallet.available} {wallet.currency}
              {wallet.holds > 0 ? ` · hold ${wallet.holds}` : ''}
            </span>
          )}
          <Link className="peers user-chip" to="/profile" title="Edit profile">
            {user?.avatarUrl ? (
              <img className="user-chip-avatar" src={mediaUrl(user.avatarUrl) || ''} alt="" />
            ) : (
              <span className="led" />
            )}
            {user?.displayName || user?.username}
          </Link>
          <button
            className="tbtn"
            type="button"
            onClick={async () => {
              await logout()
              nav('/login')
            }}
          >
            Log out
          </button>
        </div>

        <div className="lcd-strip">
          <span className="led" />
          <span>
            SERVER · AUTH OK · DEMO CREDITS ·{' '}
            {wallet ? `${wallet.available} AVAILABLE` : '—'} · NO PEAR / NO HYPERSWARM
          </span>
        </div>

        <div className="shell-body">
          <main className="main">{children}</main>
        </div>
      </div>
    </div>
  )
}

function Private({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  if (loading) return <div className="center">Loading…</div>
  if (!user) return <Navigate to="/login" replace />
  return <Shell>{children}</Shell>
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<Private><HomePage /></Private>} />
      <Route path="/discover" element={<Private><DiscoverPage /></Private>} />
      <Route path="/events/:id" element={<Private><EventPage /></Private>} />
      <Route path="/pools/:id/picks" element={<Private><PicksPage /></Private>} />
      <Route path="/rooms/:id" element={<Private><RoomPage /></Private>} />
      <Route path="/games/:id" element={<Private><GamePage /></Private>} />
      <Route path="/wallet" element={<Private><WalletPage /></Private>} />
      <Route path="/profile" element={<Private><ProfilePage /></Private>} />
      <Route path="/admin" element={<Private><AdminPage /></Private>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
